import { CmsSellerFilters, CustomCmsSeller } from '../../../../domain/seller'
import GoogleMapSellersPage from './GoogleMapSellersPage'
import { useLoadGoogleMapApi } from './helpers'

export const GoogleMapSellersPageLoadApi = ({
  sellers,
  onSubmitFilterForm,
  filters,
}: {
  sellers: CustomCmsSeller[]
  onSubmitFilterForm: (value: CmsSellerFilters) => void
  filters: CmsSellerFilters
}) => {
  const isLoaded = useLoadGoogleMapApi()

  if (!isLoaded) {
    return null
  }

  return (
    <GoogleMapSellersPage
      sellers={sellers}
      onSubmitFilterForm={onSubmitFilterForm}
      filters={filters}
    />
  )
}
